import { AxiosInstance } from 'axios';
import { GroupsRepository } from '@/model/repository/manager/groups/GroupsRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): GroupsRepository => ({
    index(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
  });
